import { MultiplyIcon, ExclamationOctagonIcon, ExclamationCircleIcon, CheckCircleIcon, ExclamationTriangleIcon } from '@koaly/koaly-ui-icons';
import { getVariantToken, getFontTokenStyle, getSizeToken, rem } from '@koaly/mixins';
import { createElement } from 'react';
import styled, { keyframes } from 'styled-components';

function getTranslate(placement) {
    const pos = placement.split('-');
    const relevantPlacement = pos[1] === 'center' ? pos[0] : pos[1];
    switch (relevantPlacement) {
        case 'right':
            return 'translate3d(120%, 0, 0)';
        case 'left':
            return 'translate3d(-120%, 0, 0)';
        case 'bottom':
            return 'translate3d(0, 120%, 0)';
        case 'top':
            return 'translate3d(0, -120%, 0)';
    }
    return '';
}
const toastStatesTransforms = (placement) => ({
    entering: getTranslate(placement),
    entered: 'translate3d(0,0,0)',
    exiting: getTranslate(placement),
    exited: getTranslate(placement),
});
const StyledToast = styled.div `
  background-color:${({ themeAppearance }) => getVariantToken('toast', 'backgroundColor', themeAppearance)};
  color: $${({ themeAppearance }) => getVariantToken('toast', 'color', themeAppearance)};
  ${getFontTokenStyle('label', 'medium')};
  box-shadow: ${({ theme }) => theme.elevations[2]};
  display: flex;
  margin-bottom: ${getSizeToken('toast', 'gutter')};
  border-radius: ${getSizeToken('toast', 'borderRadius')};
  transition: transform ${({ transitionDuration }) => transitionDuration}ms cubic-bezier(0.2, 0, 0, 1);
  transform: ${({ placement, transitionState }) => toastStatesTransforms(placement)[transitionState]};
  min-height: ${getSizeToken('toast', 'minHeight')};
`;
const Content = styled.div `
  padding: ${getSizeToken('toast', 'gutter')};
  flex-grow: 1;
  width: ${rem(304)};
  min-height:${getSizeToken('toast', 'minHeight')};
`;
const shrinkKeyframes = keyframes `
  from {
    height: 100%;
  }
  to {
    height: 0%
  }
`;
const Countdown = styled.div `
  animation: ${shrinkKeyframes} ${({ autoDismissTimeout }) => autoDismissTimeout}ms linear;
  animation-play-state: ${({ isRunning }) => isRunning ? 'running' : 'paused'};
  background-color: rgba(0, 0, 0, 0.1);
  bottom: 0;
  height: 0;
  left: 0;
  opacity: ${({ opacity }) => opacity};
  position: absolute;
  width: 100%;
`;
const LeftSide = styled.div `
  // eslint-disable-next-line max-len
  background-color: ${({ themeAppearance }) => getVariantToken('toast', 'leftBackgroundColor', themeAppearance)};
  color: ${({ themeAppearance }) => getVariantToken('toast', 'leftColor', themeAppearance)};
  border-top-left-radius: ${getSizeToken('toast', 'borderRadius')};
  border-bottom-left-radius: ${getSizeToken('toast', 'borderRadius')};
  padding-bottom:${getSizeToken('toast', 'gutter')};
  padding-top: ${getSizeToken('toast', 'gutter')};
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  text-align: center;
  width: ${rem(30)};
  min-height: ${getSizeToken('toast', 'minHeight')};
`;
const CloseLink = styled.a `
  padding-right: ${getSizeToken('toast', 'gutter')};
  padding-top: ${getSizeToken('toast', 'gutter')};
  cursor: pointer;
`;
const getIconFromAppearance = (appearance) => {
    switch (appearance) {
        case 'error':
            return ExclamationTriangleIcon;
        case 'success':
            return CheckCircleIcon;
        case 'info':
            return ExclamationCircleIcon;
        case 'warning':
            return ExclamationOctagonIcon;
    }
};
const Toast = (props) => {
    const { children, appearance, transitionDuration, transitionState, autoDismissTimeout, onDismiss, isRunning, autoDismiss, onMouseEnter, onMouseLeave, placement, } = props;
    const themeAppearance = appearance === 'error' ? 'danger' : appearance;
    const Glyph = getIconFromAppearance(appearance);
    const onDismissClick = (e) => {
        e.preventDefault();
        onDismiss();
    };
    return (createElement(StyledToast, { role: "alert", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, transitionDuration: transitionDuration, transitionState: transitionState, themeAppearance: themeAppearance, placement: placement },
        createElement(LeftSide, { themeAppearance: themeAppearance },
            createElement(Countdown, { autoDismissTimeout: autoDismissTimeout, isRunning: isRunning, opacity: autoDismiss ? 1 : 0 }),
            createElement(Glyph, { fill: "currentColor", style: { zIndex: 1, position: 'relative' } })),
        createElement(Content, null, children),
        createElement(CloseLink, { onClick: onDismissClick },
            createElement(MultiplyIcon, null))));
};

export { Toast };
//# sourceMappingURL=Toast.js.map
